
/**
 * @see /src/materials/components/component-header/component-header.js
 *
 * @description
 * Component header
 * Publish/Subscribe to header events
 *
 *	publish('component-header-toggle');
 *
 *	subscribe('component-header-change', isOpen => {
 *
 *	};
 */

import fn from 'Components/component-header/component-header--fn.partial';
import global from 'Core/global';
import Block from 'Mixins/Block';
import { publish, subscribe } from 'Mixins/pubsub';
import q from 'Utils/q';
import utils from 'Utils/utils';

const state = {
	isOpen: true,
	labelStrings: [],
	boxItemStrings: {},
	currentLabelIndex: 0,
};

let component = null;
let closeTimeout = null;
let navOrderIsSwitched = false;

export default Block('component-header', {
	fn: {
		focusLabel(which) {
			fn.focus(which, component.child('.component-header__label'));
		},
		focusBoxItem(which, event) {
			const currentBoxItems = component.child(
				'.component-header__menu-item--' +
          state.currentLabelIndex +
          ' .component-header__box-item'
			);
			const currentIndex = currentBoxItems.index(event.target);

			fn.focus(which, currentBoxItems, currentIndex, true);
		},
		checkController(checked, currentController) {
			// Fix for change event that is only fired if an event triggered the change, not if checked is toggled.
			const controllers = component.child('.component-header__controller');

			for (const controller of controllers) {
				// 	item.pause();
				// }
				// controllers.forEach(controller => {

				const index = controller
					.closest('.component-header__menu-item')
					.getAttribute('data-index');

				if (controller === currentController) {
					controller.checked = checked;
				} else {
					controller.checked = false;
				}

				controller.setAttribute('aria-checked', controller.checked);

				component
					.child(
						'.component-header__menu-item--' +
              index +
              ' .component-header__label'
					)[controller.checked ? 'setAttr' : 'removeAttr'](
						'aria-expanded',
						controller.checked
					);

				// });
			}
		},
		openBox(which) {
			const box = component.child(
				'.component-header__menu-item--' +
          state.currentLabelIndex +
          ' .component-header__box'
			);
			const boxItems = box.child('.component-header__box-item');
			const currentController = component.child(
				'#component-header__controller--' + state.currentLabelIndex
			)[0];

			if (!state.isOpen || !boxItems.length) {
				return;
			}

			this.checkController(true, currentController);
			this.setSizes();
			fn.focus(which, boxItems);
		},
		closeBox() {
			this.checkController(
				false,
				component.child(
					'#component-header__controller--' + state.currentLabelIndex
				)[0]
			);
			this.focusLabel(state.currentLabelIndex);
			this.setSizes();
		},
		initLabels() {
			const labels = component.child('.component-header__label');
			const controllers = component.child('.component-header__controller');

			// Toggle aria states and close all boxes except current
			controllers.addEvent('change', (event) => {
				this.checkController(event.target.checked, event.target);
				this.setSizes();
			});

			// Save current label index in component state object
			labels.addEvent('focus', (event) => {
				state.currentLabelIndex =
          parseInt(event.target.closest('.component-header__menu-item').getAttribute('data-index')	) || 0;
			});

			labels.addEvent('click', (event) => {
				state.currentLabelIndex =
          parseInt(event.target.closest('.component-header__menu-item').getAttribute('data-index')
          ) || 0;
			});

			// Save all labels for easy key access later
			// labels.forEach(item => {
			for (const item of labels) {
				state.labelStrings.push(item.innerText.trim().toLowerCase());
			}

			// Define actions for key events
			// See Menubar @ https://www.w3.org/TR/wai-aria-practices/examples/menubar/menubar-1/menubar-1.html
			fn.key(this, labels, {
				enter() {
					// this.openBox();
					this.openBox('first');
				},
				esc() {
					this.close();
					document.getElementById('component-header-toggle').focus();
				},
				escSub() {
					this.closeBox();
				},

			});
		},
		initBoxes() {
			// Save all box items for easy key access later
			for (const menuitem of component.child('.component-header__menu-item')) {

				const index = parseInt(menuitem.getAttribute('data-index'));

				if (utils.isNumber(index)) {
					const boxItems = component.child(
						'.component-header__menu-item--' +
              index +
              ' .component-header__box-item'
					);

					state.boxItemStrings[index] = [];

					// eslint-disable-next-line max-depth
					for (const boxItem of boxItems) {

						state.boxItemStrings[index].push(
							boxItem.innerText.trim().toLowerCase()
						);
					}
				}
			}

			// Define actions for key events
			// See Submenu @ https://www.w3.org/TR/wai-aria-practices/examples/menubar/menubar-1/menubar-1.html
			fn.key(this, component.child('.component-header__box-item'), {
				esc() {
					this.closeBox(state.currentLabelIndex);
				},
			});
		},
		setSizes() {
			const top = component.child('.component-header__top')[0];
			const nav = component.child('.component-header__menu')[0];
			const box = component.child(
				'.component-header__menu-item--' +
          state.currentLabelIndex +
          ' .component-header__box'
			)[0];
			const header = component[0];
			const body = q('.global__body')[0];
			const footer = q('footer')[0];

			if ([top, nav, header, body].includes(undefined)) {
				return;
			}
			// if ([nav, header, body].includes(undefined)) {
			// 	return;
			// }

			header.style.display = 'block'; // Show header, it has display none from start to prevent FOUC

			const size = (global.state.nav === 'mobile' ? top.offsetHeight : top.offsetHeight) + nav.offsetHeight + (global.state.nav === 'desktop' && box ? box.offsetHeight : 0);

			if (state.isOpen) {
				header.style.transform = 'translateY(0)';
				body.style.transform = 'translateY(' + size + 'px)';
				footer.style.transform = 'translateY(' + size + 'px)';
			} else {
				header.style.transform = 'translateY(-' + size + 'px)';
				body.style.transform = 'translateY(0)';
				footer.style.transform = 'translateY(0)';
			}

			// switches order of items for accessability reasons (tab order in mobile/desktop)
			const headerButtonsContainer = document.getElementsByClassName(
				'component-header__top-items'
			)[0];

			if (!navOrderIsSwitched && global.state.nav === 'mobile') {
				headerButtonsContainer.appendChild(
					headerButtonsContainer.firstElementChild
				);
				navOrderIsSwitched = true;
			} else if (
				navOrderIsSwitched === true &&
        global.state.nav === 'desktop'
			) {
				headerButtonsContainer.appendChild(
					headerButtonsContainer.firstElementChild
				);
				navOrderIsSwitched = false;
			}
			// else {
			// 	console.log('end');
			// }
		},

		open(animation) {
			const header = component[0];

			const headerBar = q('.component-header-bar')[0];

			if (!headerBar.classList.contains('component-header-bar--light')) {
				q('.component-header__top-items')[0].style.backgroundColor = '#f2f2f200';
			}

			clearTimeout(closeTimeout);

			if (header) {
				// Enable tab inside menu when open
				header.style.visibility = 'visible';
			}

			animation = animation !== false;

			this.animation(animation);

			state.isOpen = true;
			sessionStorage.setItem('isOpen', true);

			this.setSizes();

			publish('component-header-change', state.isOpen);

			setTimeout(this.animation, 500);
		},
		close(animation) {
			animation = animation !== false;

			const headerBar = q('.component-header-bar')[0];

			if (!headerBar.classList.contains('component-header-bar--light')) {
				let color = '#f2f2f2';
				setTimeout(()=> {
					q('.component-header__top-items')[0].style.backgroundColor = color;
				}, 500);
			}

			this.animation(animation);

			state.isOpen = false;
			sessionStorage.setItem('isOpen', false);

			this.checkController(false);

			this.setSizes();

			publish('component-header-change', state.isOpen);

			closeTimeout = setTimeout(() => {
				const header = component[0];

				this.animation(false);

				if (header) {
					// Prevent tab inside menu when closed
					header.style.visibility = 'hidden';
				}
			}, 500);
		},
		animation(on) {
			const body = q('.global__body')[0];
			const header = component[0];

			if ([body, header].includes(undefined)) {
				return;
			}

			body.style.transition =
        on === true ? 'transform .4s ease-in-out' : 'inherit';
			header.style.transition =
        on === true ? 'transform .4s ease-in-out' : 'inherit';
		},
		initScrollNav() {
			const qLeft = q('.component-header__menu-scroll-left');
			const qRight = q('.component-header__menu-scroll-right');
			const nav = document.querySelector('.component-header__menu-inner');
			const header = document.querySelector('.component-header');

			this.scrollNavToggle();

			qLeft.addEvent('mouseenter', () => {
				const scrollFrom = nav.scrollLeft;

				if (scrollFrom > 0) {
					this.scrollNav(scrollFrom, 0, () => {
						this.scrollNavToggle();
					});
				}
			});

			qRight.addEvent('mouseenter', () => {
				const totalWidth = this.scrollNavTotalWidth(true);
				const scrollTo = totalWidth - header.offsetWidth;

				if (nav.scrollLeft < scrollTo) {
					this.scrollNav(nav.scrollLeft, scrollTo, () => {
						this.scrollNavToggle();
					});
				}
			});
		},
		scrollNavTotalWidth(withPadding) {
			const nav = document.querySelector('.component-header__menu-inner');
			if (nav) {
				const navStyle = getComputedStyle(nav);
				// We don't want to show scroll button just because some padding is outside of the grid.
				// So padding left is enough.
				let totalWidth = parseInt(navStyle['padding-left']);

				if (withPadding) {
					// When we scroll the menu we want to scroll the whole button to fit inside the grid.
					// So then we also want padding right.
					totalWidth = totalWidth + parseInt(navStyle['padding-right']);
				}

				q('.component-header__menu-item').forEach((item) => {
					totalWidth = totalWidth + item.offsetWidth;
				});

				return totalWidth;
			}
			return null;
		},
		scrollNavToggle(resetScroll) {
			const qLeft = q('.component-header__menu-scroll-left');
			const qRight = q('.component-header__menu-scroll-right');
			const nav = document.querySelector('.component-header__menu-inner');
			const header = document.querySelector('.component-header');

			if (!header || !nav) {
				return;
			}

			if (resetScroll) {
				nav.scrollLeft = 0;
			}

			const totalWidth = this.scrollNavTotalWidth();
			const overflow = header.offsetWidth - totalWidth;

			if (overflow < 0) {
				if (nav.scrollLeft > 0) {
					qLeft.addClass('component-header__menu-scroll-left--show');
					qRight.removeClass('component-header__menu-scroll-right--show');
				} else {
					qLeft.removeClass('component-header__menu-scroll-left--show');
					qRight.addClass('component-header__menu-scroll-right--show');
				}
			} else {
				// Menu fit inside grid. Hida buttons.
				qRight.removeClass('component-header__menu-scroll-right--show');
				qLeft.removeClass('component-header__menu-scroll-left--show');
			}
		},
		scrollNav(from, to, cb) {
			const nav = document.querySelector('.component-header__menu-inner');

			if (!nav) {
				return;
			}

			const start = new Date().getTime();
			const unit = '';
			const time = 300;

			let timer = setInterval(function () {
				const step = Math.min(1, (new Date().getTime() - start) / time);

				nav.scrollLeft = from + step * (to - from) + unit;

				if (step === 1) {
					clearInterval(timer);
					if (cb) {
						cb();
					}
				}
			}, 25);
		},
	},
	onResize() {
		this.fn.setSizes();
		this.fn.scrollNavToggle(true);
	},
	onLoad(qComponent) {
		component = qComponent;

		if (!q('.global__body').length) {
			component.addClass('component-header--demo');
		}

		if (sessionStorage.getItem('isOpen') === 'true' && window.innerWidth >= global.config.size.l ) {
			this.fn.open(false);
		} else {
			this.fn.close(false);
		}

		// this.fn.close(false);
		this.fn.initLabels();
		this.fn.initBoxes();
		this.fn.initScrollNav();

		subscribe('component-header-toggle', () => {
			if (state.isOpen) {
				this.fn.close();
			} else {
				this.fn.open();
			}
		});
	},
});

